<div class="tab-container pb-3">
  <ul class="nav nav-tabs mx-auto d-flex justify-content-center flex-column flex-md-row ">
    <li *ngFor="let link of links" class="nav-item">
      <a *ngIf="!link.isExternal" class="nav-link"
         [class.active]="route?.url === ('/settings/' + link.path)"
         [routerLink]="'/settings/' + link.path"
      >{{link.text}}</a>
      <a *ngIf="link.isExternal" class="nav-link"
         [href]="link.path"
      >{{ link.text }}</a>
    </li>
  </ul>
</div>
